import React from 'react';
import { Link } from 'react-router-dom';
import {
  COMPANY_NAME,
  CONTACT_ADDRESS,
  CONTACT_EMAILS,
  CONTACT_PHONES,
  FACEBOOK_URL,
  HERO_DESCRIPTION,
  INSTAGRAM_URL,
  WHATSAPP_URL,
  YOUTUBE_URL,
} from '../constants/site';
import './footer.css';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/solutions', label: 'Solutions' },
  { to: '/projects', label: 'Projects' },
  { to: '/news', label: 'News' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

const SERVICE_LINKS = [
  { to: '/solutions', label: 'Road repair paint' },
  { to: '/solutions', label: 'Aluminum signs' },
  { to: '/solutions', label: 'Traffic signage' },
  { to: '/solutions', label: 'Safety markings' },
];

const SOCIAL_LINKS = [
  { href: FACEBOOK_URL, icon: 'fa-brands fa-facebook', label: 'Facebook' },
  { href: WHATSAPP_URL, icon: 'fa-brands fa-square-whatsapp', label: 'WhatsApp' },
  { href: YOUTUBE_URL, icon: 'fa-brands fa-youtube', label: 'YouTube' },
  { href: INSTAGRAM_URL, icon: 'fa-brands fa-instagram', label: 'Instagram' },
];

const Footer = () => (
  <footer className="vt-footer">
    <div className="vt-footer__main">
      <div className="vt-footer__grid">
        <div className="vt-footer__brand">
          <Link to="/" className="vt-footer__logo">
            <img src="/images/logo/logoedite.png" alt={`${COMPANY_NAME} logo`} />
          </Link>
          <p className="vt-footer__about">{HERO_DESCRIPTION}</p>
        </div>

        <div className="vt-footer__column">
          <h3 className="vt-footer__heading">Explore</h3>
          <ul className="vt-footer__list">
            {NAV_LINKS.map(({ to, label }) => (
              <li key={to}>
                <Link to={to}>{label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="vt-footer__column">
          <h3 className="vt-footer__heading">Services</h3>
          <ul className="vt-footer__list">
            {SERVICE_LINKS.map(({ to, label }) => (
              <li key={label}>
                <Link to={to}>{label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="vt-footer__column vt-footer__column--contact">
          <h3 className="vt-footer__heading">Get in touch</h3>
          <ul className="vt-footer__contact-list">
            <li>
              <i className="fa-solid fa-envelope" aria-hidden="true" />
              <span>
                {CONTACT_EMAILS.map((email) => (
                  <a key={email} href={`mailto:${email}`}>
                    {email}
                  </a>
                ))}
              </span>
            </li>
            <li>
              <i className="fa-solid fa-phone" aria-hidden="true" />
              <span>
                {CONTACT_PHONES.map((phone) => (
                  <a key={phone} href={`tel:${phone.replace(/\s/g, '')}`}>
                    {phone}
                  </a>
                ))}
              </span>
            </li>
            <li>
              <i className="fa-solid fa-location-dot" aria-hidden="true" />
              <span>{CONTACT_ADDRESS}</span>
            </li>
          </ul>
          <div className="vt-footer__social">
            {SOCIAL_LINKS.map(({ href, icon, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="vt-footer__social-link"
              >
                <i className={icon} aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>

    <div className="vt-footer__bar-wrap">
      <div className="vt-footer__bar">
        <p>
          © {new Date().getFullYear()} {COMPANY_NAME}. All rights reserved.
        </p>
        <p>
          Developed by{' '}
          <a href="https://aitthisone.com/" target="_blank" rel="noopener noreferrer">
            Aitthisone Dev
          </a>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
